export default __webpack_public_path__ + "static/media/confetti-TR.107dc8a7.svg";